import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../../components/dropdown/MultiSelectDropdown";

export const rowData = [];
export const colDefs = [];

export const rateColdefs = [
    {
        field: "isItemSelected",
        headerName: "Select",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
        editable: true
    },
    {
        field: "productName",
        headerName: "Item Details",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "searchText",
        headerName: "Search text",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "itemDetails",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "actualRate",
        headerName: "Actual rate",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "purchaseRate",
        headerName: "Purchase rate",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "startDate",
        headerName: "Start date",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "endDate",
        headerName: "End date",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
];

export const ItemRateVendorWisePopUp = (props) => {

    const [open, setOpen] = useState(false);

    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams={`!w-[75%] overflow-y-auto ${open ? 'h-full' : ''}`}
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
            onClose={() => { setOpen(false); }}
        >
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <div className="tabbing-btns flex gap-5 items-center mb-3">
                        <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${open ? "text-blue bg-lightBlue hover:bg-[#3f8cff33]" : "text-white bg-blue"}`} onClick={() => setOpen(false)}>Item rate revision</span>
                        <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${open ? "text-white bg-blue" : "text-blue bg-lightBlue hover:bg-[#3f8cff33]"}`} onClick={() => setOpen(true)}>Existing item details</span>
                    </div>
                    {!open && (
                        <>
                            <div className="item-inner mt-2.5 mb-2 pb-[8px] border-b border-slate-200">
                                <span className="text-blue text-[16px] font-semibold">Item master rate details</span>
                                <div className="inputOuter-grp grid grid-cols-4 col-span-2 gap-2.5 mt-[5px]">
                                    <div className="input-grp">
                                        <label>Select type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Select type"
                                            options={props.itemObject.types}
                                            value={props.itemObject.selectedType ? props.itemObject.types.find(x => x.label === props.itemObject.selectedType) : 0}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedType")
                                            }
                                            className={props.validState?.error?.selectedType !== undefined ? "error" : ""}
                                        />
                                    </div>
                                    <div className="input-grp col-span-2">
                                        <label>Vendor</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Select vendor"
                                            options={props.itemObject.vendorList}
                                            value={props.itemObject.idVendor ? props.itemObject.vendorList.find(x => x.value === props.itemObject.idVendor) : 0}
                                            onChange={(event) =>
                                                props.handleChange(event, "idVendor")
                                            }
                                            className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                                        />
                                    </div>
                                    {/* <div className="input-grp">
                                        <label>Item category</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Select category"
                                            options={props.itemObject.itemCategoryList}
                                            value={props.itemObject.idItemCategory ? props.itemObject.itemCategoryList.find(x => x.value === props.itemObject.idItemCategory) : 0}
                                            onChange={(event) =>
                                                props.handleChange(event, "idItemCategory")
                                            }
                                            className={props.validState?.error?.idItemCategory !== undefined ? "error" : ""}
                                        />
                                    </div> */}
                                    <div className="input-grp flex gap-2.5 mt-5">
                                        {/* <button className="save-btn btns" onClick={() => props.submit()}>
                                            Submit
                                        </button> */}
                                        <button className="delete-btn btns" onClick={() => props.clear()}>Clear</button>
                                    </div>
                                </div>
                            </div>
                            <span className="text-blue text-[16px] font-semibold ">Item details</span>
                            <div className="item-inner h-[48vh] pb-[8px] mt-[5px]">
                                <div className="table-inner h-full">
                                    <AgGridReact
                                        rowData={props.itemObject.revisionItemRowData}
                                        columnDefs={props.itemObject.revisionRateColdefs}
                                        onCellClicked={props.handleCellClickItemList}
                                        singleClickEdit={true}
                                        rowSelection={props.rowSelection}
                                        onRowClicked={props.onRowClicked}
                                        onCellValueChanged={props.onCellValueChanged}
                                    // onRowDoubleClicked={props.onRowDoubleClickedItemRateRevisionList}
                                    />
                                </div>
                            </div>
                            <div className="btn-grp inline-flex gap-2.5 mt-2.5">
                                <button className="update-btn btns" onClick={() => props.save()} >
                                    Save
                                </button>
                                <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                            </div>
                        </>
                    )}
                    {open && (
                        <>
                            <span className="text-blue text-[16px] font-semibold ">Existing item details</span>

                            <div className="item-inner mb-3 mt-1.5 h-[72vh]">
                                <div className="table-inner h-full">
                                    <AgGridReact
                                        rowData={props.itemObject.existingItemRowData}
                                        columnDefs={props.itemObject.existingItemColdefs}
                                        singleClickEdit={true}
                                        //onCellClicked={props.handleCellClickItemListOfExistingItem}
                                        onRowDoubleClicked={props.onRowDoubleClickedExistingItemDetailsList}
                                    />
                                </div>
                                <div className="btn-grp inline-flex gap-2.5 mt-2.5">
                                    <button className="update-btn btns" onClick={() => props.update()} >
                                        Update
                                    </button>
                                    <button className="delete-btn btns" onClick={() => props.close()}>Close</button>
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </div>
        </ModalBasic>
    );
}